import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchInput from '../SearchInput';
import styles from './styles';
import {
  getKnowledgebasebaseCategoriesRequest,
  setKnowledgebaseFilters,
  getMoreKnowledgebaseItemsRequest,
} from '../../actionCreators/knowledgebase';
import KnowledgebaseFilters from './KnowledgebaseFilters';
import { logFirebaseEvent } from '../../firebase/analytics';
import KnowledgebaseItem from './KnowledgebaseItem';
import GridContainer from '../global/GridContainer/GridContainer';
import { fetchFeatureFlagsRequest } from '../../actionCreators/featureFlags';
import KnowledgebaseApi from '../../api/knowledgebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate } from 'react-router-dom';

const KnowledgebaseComponent = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [state, setState] = useState({
    searchText: '',
  });

  const [categories, setCategories] = useState();
  const [categorySelected, setCategorySelected] = useState(0);
  const [isSimulatingLoad, setIsSimulatingLoad] = useState(false);
  const loadTimerRef = React.useRef(null);
  const featureFlags = useSelector((state) => state.featureFlags);

  const scrollBlock = React.createRef();
  const contentBlock = React.createRef();

  useEffect(() => {
    if (!categories || categories.length === 0) return;

    const params = new URLSearchParams(location.search);
    const rawCategoryParam = params.get('category');
    
    const categoryParam = rawCategoryParam
      ? rawCategoryParam.replace(/-/g, ' ')
      : null;

    if (!categoryParam) {
      setCategorySelected(0);

      const clearedFilters = props.filterGroups.map((group) => ({
        ...group,
        filters: group.filters.map((f) => ({ ...f, isChecked: false })),
      }));

      props.setKnowledgebaseFilters(
        clearedFilters,
        state.searchText,
        props?.currentUser?.language_id,
      );
      return;
    }

    const category = categories.find(item => item.name.toLowerCase() === categoryParam);

    if (category) {
      if (Number.isNaN(category.id)) return;

      setIsSimulatingLoad(true);
      if (loadTimerRef.current) clearTimeout(loadTimerRef.current);
      loadTimerRef.current = setTimeout(() => setIsSimulatingLoad(false), 1000);

      const exists = categories.some((c) => c.id === category.id);
      if (!exists) return;
  
      setCategorySelected(1);
      toggleFilterByGroupAndId('categories', category.id);
    }
  }, [location.search, categories]);

  useEffect(() => {
    props.fetchKnowledgebaseCategories();

    const fetchCategories = async () => {
      const result = await KnowledgebaseApi.getknowledgebaseCategories();
      setCategories(result.categories);
    };

    fetchCategories();

    logFirebaseEvent({
      event: 'knowledgebase',
      action: 'load',
    });
    dispatch(fetchFeatureFlagsRequest());

    return () => {
      if (loadTimerRef.current) clearTimeout(loadTimerRef.current);
    };
  }, []);

  const search = (searchText) => {
    setState({ searchText });
    props.setKnowledgebaseFilters(props.filterGroups, searchText, props?.currentUser?.language_id);
  };

  const _onScroll = () => {
    const height = scrollBlock.current.offsetHeight;
    const scroll = scrollBlock.current.scrollTop;
    const contentHeight = contentBlock.current.offsetHeight;
    if (height + scroll >= contentHeight - 60) {
      props.fetchMoreKnowledgebaseItems(props.filterGroups, state.searchText, props?.currentUser?.language_id);
    }
  };

  const toggleFilterByGroupAndId = (groupId, filterId) => {
    const tmpFilterGroups = [...props.filterGroups];
    const filterGroupIndex = tmpFilterGroups.findIndex((filterGroup) => filterGroup.id === groupId);
    if (filterGroupIndex === -1) return;

    const filterIdIndex = tmpFilterGroups[filterGroupIndex].filters.findIndex(
      (filter) => filter.id === filterId,
    );
    if (filterIdIndex === -1) return;

    const isChecked = tmpFilterGroups[filterGroupIndex].filters[filterIdIndex].isChecked;
    tmpFilterGroups[filterGroupIndex].filters[filterIdIndex].isChecked = !isChecked;

    props.setKnowledgebaseFilters(tmpFilterGroups, state.searchText, props?.currentUser?.language_id);
  };

  const convertFAIconName = (iconName) => {
    if (!iconName || typeof iconName !== 'string') return ['fas', 'question-circle'];

    const match = iconName.match(/^fa([A-Z].*)$/);
    if (!match) return ['fas', 'question-circle'];

    const kebab = match[1].replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

    return ['fas', kebab];
  };

  return (
    <div className="knowledgebase" ref={scrollBlock} onScroll={_onScroll}>
      <GridContainer>
        <div className="knowledgebase-header">
          <p className="knowledgebase-header-title">Knowledgebase</p>
          <p className="knowledgebase-header-subtitle-text">
            Explore files and info from around the company
          </p>
        </div>
        {featureFlags?.TILED_KNOWLEDGEBASE && categorySelected === 1 && (
          <div>
            <br />
            <p
              onClick={() => {
                setCategorySelected(0);

                const clearedFilters = props.filterGroups.map((group) => ({
                  ...group,
                  filters: group.filters.map((f) => ({ ...f, isChecked: false })),
                }));

                props.setKnowledgebaseFilters(clearedFilters, state.searchText, props?.currentUser?.language_id);

                const params = new URLSearchParams(location.search);
                params.delete('category');
          
                const search = params.toString();
                navigate(
                  search ? `${location.pathname}?${search}` : location.pathname,
                  { replace: true }
                );
              }}
              style={{ cursor: 'pointer' }}
            >
              Back to categories
            </p>
          </div>
        )}
        <div className="knowledgebase-content" ref={contentBlock}>
          {(!featureFlags?.TILED_KNOWLEDGEBASE || categorySelected === 1) && (
            <>
              <SearchInput submit={search} placeholder="Search Knowledgebase" />
              <br />
            </>
          )}
          {!featureFlags?.TILED_KNOWLEDGEBASE && (
            <KnowledgebaseFilters searchTxt={state.searchText} />
          )}
          {featureFlags?.TILED_KNOWLEDGEBASE && categorySelected === 0 && (
            <div
              className="my-ark-knowledgebase-parent-container"
              style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}
            >
              <div
                className="my-ark-knowledgebase-parent-container"
                style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}
              >
                {categories?.map((category) => (
                  <div
                    key={category.id}
                    className="my-ark-knowledgebase-child-container"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setIsSimulatingLoad(true);
                      if (loadTimerRef.current) clearTimeout(loadTimerRef.current);
                      loadTimerRef.current = setTimeout(() => setIsSimulatingLoad(false), 1000);

                      setCategorySelected(1);
                      toggleFilterByGroupAndId('categories', category.id);
                    }}
                  >
                    <div className="my-ark-knowledgebase-category-icon-box">
                      <FontAwesomeIcon
                        icon={convertFAIconName(category.icon_name)} // returns ['fas', 'pizza-slice']
                        size="2x"
                        color={category.icon_colour ?? '#505A62'}
                      />
                    </div>
                    <div>
                      <p className="my-ark-knowledgebase-category-text">
                        {category.name.length > 15
                          ? `${category.name.slice(0, 15)}...`
                          : category.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {(!featureFlags?.TILED_KNOWLEDGEBASE || categorySelected === 1) && (
            <>
              {isSimulatingLoad ? (
                <p>Loading...</p>
              ) : (
                <div style={styles.postListContainer}>
                  {props.knowledgebaseItems.map((item) => {
                    return <KnowledgebaseItem item={item} />;
                  })}
                </div>
              )}
            </>
          )}
        </div>
      </GridContainer>
    </div>
  );
};

const Knowledgebase = (props) => {
  const state = useSelector((state) => ({
    filterGroups: state.knowledgebase.filters,
    knowledgebaseItems: state.knowledgebase.items,
    currentUser: state.currentUser.userData,
  }));

  const dispatch = useDispatch();

  const actions = {
    fetchKnowledgebaseCategories: () => dispatch(getKnowledgebasebaseCategoriesRequest()),
    fetchMoreKnowledgebaseItems: (filters, search, language) =>
       dispatch(getMoreKnowledgebaseItemsRequest({ filters, search, language })),
    setKnowledgebaseFilters: (filters, search, language) =>
      dispatch(setKnowledgebaseFilters({ filters, search, language })),
  };

  return <KnowledgebaseComponent {...props} {...state} {...actions} />;
};

export default Knowledgebase;
